import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};

var SquareStackPlay = function SquareStackPlay(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return React.createElement('svg', {
    height: size,
    viewBox: '0 0 16 16',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    d: 'M14.0005 5.06699V13.6003C14.0005 13.7064 13.9584 13.8082 13.8833 13.8832C13.8083 13.9582 13.7066 14.0003 13.6005 14.0003H5.06716C4.96107 14.0003 4.85933 13.9582 4.78432 13.8832C4.7093 13.8082 4.66716 13.7064 4.66716 13.6003V5.06699C4.66716 4.96091 4.7093 4.85916 4.78432 4.78415C4.85933 4.70913 4.96107 4.66699 5.06716 4.66699H13.6005C13.7066 4.66699 13.8083 4.70913 13.8833 4.78415C13.9584 4.85916 14.0005 4.96091 14.0005 5.06699Z',
    stroke: color,
    strokeWidth: '0.973333',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement('path', {
    d: 'M12.0003 2.66699H3.06699C2.96091 2.66699 2.85916 2.70913 2.78415 2.78415C2.70913 2.85916 2.66699 2.96091 2.66699 3.06699V12.0003M8.60633 7.69699C8.5456 7.66051 8.47627 7.64081 8.40543 7.6399C8.3346 7.639 8.26479 7.65692 8.20315 7.69184C8.14151 7.72676 8.09025 7.77743 8.05462 7.83866C8.01898 7.89989 8.00024 7.96948 8.00033 8.04033V10.627C8.00024 10.6978 8.01898 10.7674 8.05462 10.8287C8.09025 10.8899 8.14151 10.9406 8.20315 10.9755C8.26479 11.0104 8.3346 11.0283 8.40543 11.0274C8.47627 11.0265 8.5456 11.0068 8.60633 10.9703L10.7617 9.67699C10.821 9.64149 10.8702 9.5912 10.9043 9.53102C10.9385 9.47085 10.9564 9.40284 10.9564 9.33366C10.9564 9.26447 10.9385 9.19647 10.9043 9.13629C10.8702 9.07612 10.821 9.02582 10.7617 8.99032L8.60633 7.69699Z',
    stroke: color,
    strokeWidth: '0.973333',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

SquareStackPlay.propTypes = propTypes;
export default SquareStackPlay;